import { SEND_FIRST_DROP_DARE_EMAIL } from 'root/src/shared/descriptions/endpoints/endpointIds'
import sendFirstDropDareEmailPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/sendFirstDropDareEmailPayloadSchema'

export default {
	[SEND_FIRST_DROP_DARE_EMAIL]: {
		payloadSchema: sendFirstDropDareEmailPayloadSchema,
	},
}
